export default {
  contact_safeex: "Contact {company}",
  field_empty: "This field cannot be empty.",
  google: "Sign in with Google",
  login_error_message: "Incorrect Email or Password",
  microsoft: "Sign in with Microsoft",
  or: "or",
  pale_text_lifebuoy:
    "Oh, it's quite simple. If you are a friend, you speak the password and the doors will open.",
  subtitle: "Enter your credentials to start work",
  text_lifebuoy_instructions: "You’ll need an account and a client-subscription to proceed.",
  text_lifebuoy_support: "Contact your administrator or contact {support} using the link below. ",
  text_lifebuoy_welcome: "This is {product}, welcome!",
  title: "Log in",
  to: "to",
  welcome: "Welcome!",
}
